module.exports = __webpack_public_path__ + "img/w3_cloud_dark.171b77fb.png";